package com.vizio.redwolf.auth.model

data class WebEmailVerificationRequestInfo(val accessToken: String, val emailVerificationToken: String)